var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCart = function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M7.992 18a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M15.992 18a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.492 0a1 1 0 1 0 0 2h.439a1 1 0 0 1 .97.757l2.242 8.97A3 3 0 0 0 8.053 14h7.835a3 3 0 0 0 2.928-2.35l1.111-5A3 3 0 0 0 17 3H5.023l-.182-.728A3 3 0 0 0 1.931 0z"
  })));
};
export default SvgCart;